import { useEffect } from 'react'
import { HttpTransportType, HubConnectionBuilder, JsonHubProtocol, LogLevel } from '@microsoft/signalr'
import { apiBaseUrl } from 'config'
import { useAuth } from 'Contexts/AuthProvider'

const buildHubUrl = (company) => company ? `${apiBaseUrl}/ws/pumping-schedule?companyid=${company.id}` : `${apiBaseUrl}/ws/pumping-schedule`
const protocol = new JsonHubProtocol()
const transport = HttpTransportType.WebSockets

const LiveJobSignalrPumpingSchedule = props => {

    const {
        jobId,
        onIncomingData,
    } = props

    const { token, currentCompany } = useAuth()

    useEffect(() => {
        const options = {
            skipNegotiation: true,
            transport,
            accessTokenFactory: () => {
                return token
            },
            headers: {
                authorization: token ? `Token ${token}` : ``
            }
        }
        const connection = new HubConnectionBuilder()
            .withUrl(buildHubUrl(currentCompany), options)
            .withAutomaticReconnect()
            .withHubProtocol(protocol)
            .configureLogging(LogLevel.Information)
            .build()

        const dataHandler = data => {
            onIncomingData(data)
        }

        connection.on('PumpingScheduleDataUpdated', dataHandler)

        connection.start().then(() => {
            connection.invoke('SubscribeToPumpingScheduleUpdates', jobId).then(() => {
            })
        })

        return () => {
            if (connection.state === 'Connected')
                connection.stop()
        }
    }, [jobId, onIncomingData, token, currentCompany])

    return null
}

export default LiveJobSignalrPumpingSchedule
